// extracted by mini-css-extract-plugin
export default {"mainBox":"mainBox-fea7","subBox":"subBox-451a","messageBox":"messageBox-e1dc","mainText":"mainText-854b","fadeIn":"fadeIn-f10c","fadeOut":"fadeOut-3328"};